import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAlignLeftComponent } from "./med-icon-align-left.component";

@NgModule({
  declarations: [
    MedIconAlignLeftComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconAlignLeftComponent,
  ],
})
export class MedIconAlignLeftModule { }
